import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from "@mui/material";
import { OffTableCoachToolsEditor } from "../../components/planning/OffTableCoachToolsEditor";
import { coachToolsFromExercise } from "../../utils/teCoachTools";
import { editexercise } from "../../components/funtionsBD/Mainservice";
import {
  LIVE_TRAINING_DIALOG_Z_INDEX,
  useLiveTrainingPortalRoot,
} from "../../hooks/useLiveFullscreen";

export function LiveTrainingExerciseSetupDialog({
  open,
  onClose,
  exercise,
  tsId,
  onSaved,
}) {
  const { t } = useTranslation();
  const portalRoot = useLiveTrainingPortalRoot();
  const [tools, setTools] = useState(() => coachToolsFromExercise(exercise, { defaultChrono: false }));
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open) return;
    setTools(coachToolsFromExercise(exercise, { defaultChrono: false }));
    setError("");
  }, [open, exercise]);

  const save = async () => {
    if (!exercise?.te_id || !tsId) return;
    setSaving(true);
    setError("");
    try {
      await editexercise({
        te_id: exercise.te_id,
        ts_id: tsId,
        te_coach_tools: {
          chrono: Boolean(tools.chrono),
          count: Boolean(tools.count),
          count_label: tools.count ? String(tools.count_label || "").trim() : "",
        },
      });
      onSaved?.();
      onClose?.();
    } catch (err) {
      setError(err?.message || t("errorSaving") || "Could not save exercise setup");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={saving ? undefined : onClose}
      fullWidth
      maxWidth="xs"
      container={portalRoot || undefined}
      disableScrollLock
      sx={{ zIndex: LIVE_TRAINING_DIALOG_Z_INDEX }}
    >
      <DialogTitle>{t("liveTrainingExerciseSetup", "Exercise setup")}</DialogTitle>
      <DialogContent>
        <OffTableCoachToolsEditor value={tools} onChange={setTools} disabled={saving} />
        {error ? (
          <p className="lt-coach-dash__error" role="alert">
            {error}
          </p>
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>
          {t("cancel") || "Cancel"}
        </Button>
        <Button variant="contained" onClick={save} disabled={saving}>
          {t("save") || "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
